import { useTranslation } from "react-i18next";
import { FaBlogger } from "react-icons/fa";

const MarketingAdmin = () => {
  const { t } = useTranslation();

  const marketingAdminNavArray = [
    // ------- Dashboard -------
    {
      id: "dashboard",
      title: t("navigation.superAdmin.dashboard"),
      icon: (
        <svg
          width="18px"
          height="18px"
          className="remix-icon"
          viewBox="0 0 1024 1024"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#000000"
            d="M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"
          ></path>
        </svg>
      ),
      navLink: "/marketing-admin/dashboard",
    },
    // ------- Visitors -------
    {
      id: "visitors",
      title: "Visitors",
      icon: (
        <svg
          width="18px"
          height="18px"
          className="remix-icon"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#bfc7cb"
            d="M46.594 50.28c0 7.577-6.625 13.723-14.797 13.723c-8.171 0-14.796-6.146-14.796-13.723V13.724c0-7.577 6.625-13.721 14.795-13.721c8.172 0 14.797 6.144 14.797 13.721V50.28z"
          />
          <path
            fill="#1f2e35"
            d="M44.46 48.716c0 6.938-5.624 12.562-12.564 12.562c-6.938 0-12.564-5.624-12.564-12.562v-33.47c0-6.938 5.626-12.564 12.564-12.564c6.94 0 12.564 5.626 12.564 12.564v33.47"
          />
          <path
            fill="#152228"
            d="M26.849 48.714V15.246c0-5.631 3.706-10.395 8.806-11.993a12.567 12.567 0 0 0-3.758-.572c-6.938 0-12.564 5.626-12.564 12.564v33.468c0 6.94 5.626 12.564 12.564 12.564c1.309 0 2.572-.2 3.758-.573c-5.1-1.595-8.806-6.361-8.806-11.99"
          />
          <circle cx="31.897" cy="13.656" r="8.121" fill="#ec1c24" />
          <circle cx="31.897" cy="31.979" r="8.121" fill="#ffdd15" />
          <circle cx="31.897" cy="50.26" r="8.121" fill="#4fba80" />
        </svg>
      ),
      navLink: "/marketing-admin/visitors",
    },
    // ------- Email -------
    {
      id: "email",
      title: "Email",
      icon: (
        <svg
          className="remix-icon"
          width="18px"
          height="18px"
          data-slot="icon"
          fill="none"
          stroke-width="1.5"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z"
          ></path>
        </svg>
      ),
      navLink: "/marketing-admin/email/email-campaigns",
    },

    // ------- Blogs -------
    {
      id: "blogs",
      title: t("navigation.superAdmin.blogs"),
      icon: <FaBlogger set="curved" className="remix-icon" />,
      navLink: "/marketing-admin/blogs",
    },

    // ------- SEO -------
    {
      id: "seo",
      title: "SEO",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="remix-icon"
          width="18px"
          height="18px"
          viewBox="0 0 48 48"
        >
          <mask id="ipSSeo0">
            <g fill="none" stroke-width="4">
              <rect
                width="40"
                height="32"
                x="4"
                y="8"
                fill="#fff"
                stroke="#fff"
                rx="1.633"
              />
              <path
                stroke="#000"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16 18.948c-2-2.948-5.502-1.01-5.251 2.02C11 24 15 24 15.249 27.032C15.5 30.062 12 32 10 29.051M26 18h-4v13h4m-4-6h4"
              />
              <rect
                width="6"
                height="13"
                x="32"
                y="18"
                stroke="#000"
                stroke-linecap="round"
                stroke-linejoin="round"
                rx="3"
              />
            </g>
          </mask>
          <path fill="currentColor" d="M0 0h48v48H0z" mask="url(#ipSSeo0)" />
        </svg>
      ),
      navLink: "/marketing-admin/seo/ai-apps",
    },
  ];
  return { marketingAdminNavArray };
};

export default MarketingAdmin;
